<template>
  <div class="container-fluid sticky-top bg-white progressShadow shadow" :class="{shadow: scrollPosition}"
       @scroll="updateScroll">
    <div class="container">
      <div class="row">
        <div class="col-11 col-lg-9 my-auto mx-auto pt-0">
          <p class="text-center" style="font-weight: 700; margin-bottom: 0.03rem">
            {{ text }}
          </p>
          <div class="row d-flex justify-content-center">
            <div class="col-1 noIconSpacing">
              <i class="far fa-flag-checkered text-success" style="font-size: 1.5rem"></i>
            </div>
            <div class="col-10 my-auto text-center">
              <div class="progress" style="height: 0.75rem; border-radius: 30px">
                <div :style="{width: progress}" class="progress-bar bg-success" role="progressbar"
                     aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
            <div class="col-1 noIconSpacing text-right">
              <i class="fas fa-car-garage" style="font-size: 1.5rem"></i>
            </div>
          </div>

        </div>
        <div class="col-3 d-none d-lg-block my-auto" style="text-align: center">
          <img v-if="imageUrl"
               :style="{ width: scrollPosition ? '100%' : '150px', transition: transition}"
               :src="imageUrl"
               alt="">
          <img v-else src="https://faa-files.storage.googleapis.com/autos/no_preview_available.jpg"
               :style="{ width: scrollPosition ? '100%' : '150px', transition: transition}"
               alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    progress: {
      type: String,
      required: false,
      default: "100%"
    },
    imageUrl: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      scrollPosition: false,
      width: "100%",
      transition: "width 1s",
    };
  },
  methods: {
    updateScroll () {
      const scrollLimit = 60;
      if (window.scrollY <= scrollLimit) {
        this.scrollPosition = false;
        this.width = "100%";
      } else if (window.scrollY > scrollLimit) {
        this.scrollPosition = true;
        this.width = "150px";
      }

    }
  },

  computed: {
    text () {
      if (parseInt (this.progress) === 100) {
        return this.$t('vue.checkout.progressBar.congratulation')
      }
      return this.$t('vue.checkout.progressBar.info')
    }
  },

  mounted () {
    this.width = "150px";
    /* window.addEventListener('scroll', this.updateScroll); */
  }

}
</script>

<style scoped>
.noIconSpacing {
  flex: 0;
}
</style>
